import { useTranslation } from "react-i18next"
import { ExternalResourcePage } from "@/components/ExternalResourcePage/ExternalResourcePage"

const legalResources = {
    terms: { title: "Terms of Use", src: "https://aidocr.com/legal/terms-of-use.html" },
    privacy: { title: "Privacy Policy", src: "https://aidocr.com/legal/privacy-policy.html" },
    disclaimer: { title: "Disclaimer", src: "https://aidocr.com/legal/disclaimer.html" },
    eula: { title: "End User License Agreement", src: "https://aidocr.com/legal/EULA.html" },
} as const

function LegalPage({ resource, fullPage = false }: { resource: keyof typeof legalResources; fullPage?: boolean }) {
    const { t } = useTranslation()
    const { title, src } = legalResources[resource]
    return <ExternalResourcePage title={t(title)} src={src} fullPage={fullPage} />
}

export const PrivacyPolicyInner = () => <LegalPage resource="privacy" />
export const EULAInner = () => <LegalPage resource="eula" />
export const DisclaimerInner = () => <LegalPage resource="disclaimer" />
export const TermsOfUseInner = () => <LegalPage resource="terms" />
export const TermsOfUsePage = () => <LegalPage resource="terms" fullPage />
export const PrivacyPolicyPage = () => <LegalPage resource="privacy" fullPage />
export const DisclaimerPage = () => <LegalPage resource="disclaimer" fullPage />
export const EULAPage = () => <LegalPage resource="eula" fullPage />
